(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentDepartmentController', IncidentDepartmentController);

    IncidentDepartmentController.$inject = ['GenericEntityDatatableService', 'CoreService', 'IncidentDepartment', '$q',
        '$uibModal', 'ConfirmationService'];

    function IncidentDepartmentController(GenericEntityDatatableService, CoreService, IncidentDepartment, $q,
                                          $uibModal, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Incident Department',
            newButtonTitle: 'New Incident Department',
            entityClassHumanized: 'Incident Department',
            entityStateName: 'incident-department',
            service: IncidentDepartment,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Incident Department',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/incident-department/update/incident-department-dialog.html',
                controller: 'IncidentDepartmentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/incident-department/update/incident-department-dialog.html',
                controller: 'IncidentDepartmentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['IncidentDepartment', function (IncidentDepartment) {
                        return IncidentDepartment.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Incident Department').result.then(function () {
                    IncidentDepartment.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
